// Material ui
import { PaletteColor, PaletteColorOptions, ThemeOptions } from '@mui/material/styles';
import { createTheme } from './theme.utils';
// Theme specifications
import breakpoints from './breakpoints-options';
import components from './components-overrides';
import typography from './typography-options';
import palette from './palette-options';
import shadows from './shadows-options';
import spacing from './spacing-options';
import shape from './shape-options';

declare module '@mui/material/styles' {
  interface Theme {
    rawSpacing: (spacing: number) => number;
  }

  interface Palette {
    tertiary: PaletteColor;
    border?: Partial<TypeBorder>;
    icon?: Partial<TypeIcon>;
  }

  interface PaletteOptions {
    tertiary: PaletteColorOptions;
    border?: Partial<TypeBorder>;
    icon?: Partial<TypeIcon>;
  }

  interface TypeBackground {
    image: string;
    table: string;
    input: string;
  }

  interface TypeBorder {
    primary: string;
    secondary: string;
    tertiary: string;
    selected: string;
    input: string;
  }

  interface TypeIcon {
    primary: string;
    secondary: string;
    tertiary: string;
    textPrimary: string;
    textSecondary: string;
    contrast: string;
  }
}

export const defaultThemeOptions: ThemeOptions = {
  spacing,
  shape,
  palette,
  components,
  shadows,
  typography,
  breakpoints,
};

const defaultTheme = createTheme(defaultThemeOptions);

export default defaultTheme;
